module.exports = __webpack_public_path__ + "images/stop_point.da09253a3049809545615a72dc3a4976.png";